<template>
  <div class="dashboard">
  <!-- Navbar -->
    <nav class="navbar navbar-expand-sm bg-color">
      <div class="navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item text-right">
            <a class="buttons" v-on:click="logout"><i class="fas fa-power-off"></i> Sair </a>
          </li> 
        </ul>
      </div>
    </nav>

<!-- Main Content -->
    <div class="container-fluid">
      <div class="row justify-content-center">
        <main role="main" class="col-md-11 ml-sd-auto col-lg-9">
          <div class="inner-adjust">

            <div class="pt-3 pb-2 mb-3 border-bottom">
              <h1 class='h2'> Ol&aacute;, {{user.displayName}}</h1>
            </div>

            <div class="row">
              <div class="col-md-3 col-lg-2">
                <div class="media justify-content-center">
                  <img class="align-self-start mr-5 img-thumbnail rounded-circle img-fluid" v-bind:src="user.photoURL" alt="User">
                </div>
              </div>
              <div class="col-md-9 col-lg-10">
                <div class="media-body">
                  <div class="form-horizontal"> 
                    <div class='form-group'>
                      <label class='text-left'> Digite sua nova senha                      
                        <div class='help-tip'> 
                          <i class="far fa-question-circle fa-lg"></i> 
                          <p>
                            Crit&eacute;rios para valida&ccedil;&atilde;o da senha: <br>
                            - Tamanho m&iacute;nimo de 8 caracteres <br>
                            - N&atilde;o possuir nenhum nome ou sobrenome <br>
                            - N&atilde;o possuir seu login <br>
                            - Ser diferente das 3 &uacute;ltimas senhas <br>
                            - Possuir caractere especial (ex: @!#$%&) <br>
                            - Possuir letras mai&uacute;sculas e min&uacute;sculas  <br>
                            - Possuir pelo menos um número<br>
                          </p>
                        </div> 
                      </label> 
                      <input type='password' id="senha" placeholder="Digite a nova senha" class='form-control' v-bind:class="{'is-invalid': !senha_valida && preenchido}" v-model="senha" v-on:blur="validarSenha()">
                      <span v-if="preenchido && !senha_valida" class="invalid-feedback">Senha inv&aacute;lida, verifique os crit&eacute;rios!</span>
                    </div>

                    <div class="form-group"> 
                      <label class='text-left'> Confirme a senha </label>
                      <input type='password' id="confirmar_senha" placeholder="Repetir Senha" class='form-control' v-bind:class="{'is-invalid': !senha_confirmada && preenchido}" v-model="confirmacao_senha" v-on:keyup="validarConfirmacao()">
                      <span v-if="preenchido && !senha_confirmada" class="invalid-feedback">A senha n&atilde;o corresponde a sua confirma&ccedil;&atilde;o!</span>
                    </div>

                    <div class="form-group text-right"> 
                      <button type="submit" class='btn button-change-password text-right' id='enviar_senhas' v-on:click="send_password()" :disabled="!senha_valida || !senha_confirmada"> Trocar senha</button>
                    </div>      
                  </div>  
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>

    <ol class="pacotes">
      <li class="pacote imgCin">
        <img src="../assets/logo-vertical.png" alt="Logo do CIn (Centro de Informática)" class="cin">
      </li>
      <li class="pacote texto" style="margin-top: auto; margin-bottom: auto;">
        <small>
          <h6>
            © Centro de Informática UFPE - Todos os direitos reservados
          </h6>
        </small>
      
        <small>
          <h6> Tel +55 81 2126.8430 - Cidade Universitária - 50740-560 - Recife/PE</h6>
        </small>
      </li>
      <li class="pacote imgUfpe">
          <img src="../assets/marca_UFPE_producao2_RGB-02.png" alt="Logo da UFPE (Universidade Federal de Pernambuco)" class="ufpe">
      </li>
    </ol>
  </div>
</template>

<script>
import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/auth';

export default { 
  name: 'Dashboard',
  data () {
    return {
      senha: '',
      confirmacao_senha: null,
      preenchido: false,
      senha_valida: false,
      msg_erro_senha: '',
      senha_confirmada: false,
      user: this.getData('user')
    }
  },
  methods: {
    logout: function(){
      firebase.auth().signOut().then(() => {
        sessionStorage.removeItem('user');
        this.$router.replace('/')
      })
      
    },
    getData: function(key){
      return JSON.parse(sessionStorage.getItem(key));
    },

    async validarSenha () {
      this.preenchido = true;

      try {
        this.senha_valida = true;
        let optionalCriteria = []
        let requiredCriteria = []
        
        optionalCriteria.push(this.validarCaracterEspecialSenha(this.senha))
        optionalCriteria.push(this.validarLetraMinusculaSenha(this.senha))
        optionalCriteria.push(this.validarLetraMaiusculaSenha(this.senha))
        optionalCriteria.push(this.validarNumeroSenha(this.senha))
        
        let optionalCount = 0;
        
        for (let i = 0; i < optionalCriteria.length; i ++){
          if (optionalCriteria[i]){ optionalCount ++;}
        }
        if (optionalCount < 3) {this.senha_valida = false;}


        requiredCriteria.push(this.validarTamanhoSenha(this.senha))
        requiredCriteria.push(this.validarNomeSenha(this.senha))
        requiredCriteria.push(this.validarLoginSenha(this.senha))

        for (let i = 0; i < requiredCriteria.length; i++){
          if (requiredCriteria[i] == false){
            this.senha_valida = false;
            break;
          }
        }

        this.validarConfirmacao()

      } catch (e) {
        console.log("TCL: validarSenha -> e", e)
      }
    },

    validarNomeSenha(senha){
      let nomes = this.user.displayName.split(" ");
      for (let i = 0; i < nomes.length; i++){
        if (senha.includes(nomes[i])){
          return false;
        }
      }
      return true;

    },

    validarLoginSenha(senha){
      let login = this.user.email.split("@");
      if (!senha.includes(login[0])){
        return true;
      } else{
        return false;
      }
    },

    validarTamanhoSenha (senha) {
      if(senha.length >= 8) {
        return true;
      } else {
        return false;
      } 
    },
    
    validarCaracterEspecialSenha(senha){
      if(senha.match(new RegExp(/[^\w\s]/gi))){
        return true;
      } else {
        return false;
      }
    },

    validarLetraMinusculaSenha(senha){
      if(senha.match(new RegExp(/[a-z]/))){
        return true;
      } else {
        return false;
      }
    },

    validarLetraMaiusculaSenha(senha){
      if(senha.match(new RegExp(/[A-Z]/))){
        return true;
      } else {
        return false;
      }
    },

    validarNumeroSenha(senha){
      if(senha.match(new RegExp(/[0-9]/))){
        return true;
      } else {
        return false;
      }
    },

    validarConfirmacao () {
      if (this.senha == this.confirmacao_senha) {
        this.senha_confirmada = true;
      } else {
        this.senha_confirmada = false;
      }
    },

    async send_password() {
      if (this.senha_valida){
        axios({
          method: 'put',
          url: process.env.VUE_APP_API_URL + "/password", 
          headers: {
            'Token': this.getData('token')
          },
          data: {
            password: this.senha,
            email: this.user.email
          }
        })
        .then((result) => {

          alert(result.data.data);
          this.logout();
        })
        .catch((error) => {
          try {
            alert(error.response.data.errors[0])
          } catch {
            alert("Ocorreu um erro inesperado, tente novamente mais tarde !" );
          }
          
          this.logout();
        })     
      }
    }
  }
}
</script>

<style lang="scss">
body {
  width: 100%;
}

main {
  padding-top: 50px;
}

label {
  font-size: 15px;
}

.form-group {
  .invalid-feedback {
    display: block;
    color: red;
    margin-top: 3px;
  }
}

.fa-question-circle {
  color: #D50022;
}

.bg-color {
  background-color: #D50022;
}

.media {
  display: block;
  margin: auto;
  max-width: 150px;
  .rounded-circle {
    max-width: 100%;
    margin: 5px auto !important;
    display: block;
  }
}

.buttons { 
  color: white !important;  
  background-color: #D50022;
  border: 0; 
  cursor: pointer;
}

.buttons:hover { 
  color: lightcoral;  
}

#enviar_senhas {
  color: white;
  background-color: #DB1E2F;
  &:hover{
    background-color: #D50022;
  }
}

.help-tip{
  position: relative;
  display: inline-block;
  text-align: center;
  background-color:white;
  width: 24px;
  height: 24px;
  font-size: 14px;
  line-height: 26px;
  cursor: default;

  &:hover p {
    display:block;
    transform-origin: 100% 0%;
    -webkit-animation: fadeIn 0.3s ease-in-out;
    animation: fadeIn 0.3s ease-in-out;
  }

  p {
    display: none;
    text-align: left;
    background-color: #1E2021;
    padding: 20px;
    width: 300px;
    position: absolute;
    border-radius: 3px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    right: -150px;
    color: #FFF;
    font-size: 13px;
    line-height: 1.4;
    
    &:before {
      position: absolute;
      content: '';
      width:0;
      height: 0;
      border:6px solid transparent;
      border-bottom-color:#1E2021;
      right: 156px;
      top:-12px;
    }
    &:after {
      width:100%;
      height:40px;
      content:'';
      position: absolute;
      top:-40px;
      left:0;
    }
  } 
}

@-webkit-keyframes fadeIn {
    0% { 
        opacity:0; 
        transform: scale(0.6);
    }

    100% {
        opacity:100%;
        transform: scale(1);
    }
}

@keyframes fadeIn {
    0% { opacity:0; }
    100% { opacity:100%; }
}

.pacotes {
  width: 100%;
  height: 10%;
  display: flex;
  flex-wrap: wrap;
  padding-top: 5%;
  padding-bottom: auto;
  padding-left: 0;
  .pacote {
    flex: 1 1 230px;
    list-style: none;
    padding: 0 5% 10px;
    text-align: center;
    padding-top: 10%;
    .ufpe {
      margin-top: -30px;
    }
    img {
      max-height: 130px;
      max-width: 200px;
      width: auto;
      height: auto;
    }
  }
}

</style>